import { storage } from '~/common/utils/storage';
import axios from '~/common/plugins/axios.js'
export const state = () => ({
  payRefresh: 1, //支付完成后，需要在某些时机刷新页面
});

export const mutations = {
  set_payRefresh(state, v) {
    state.payRefresh = v;
  },
  
};
export default {
	namespaced: true,
	state,
	mutations,
}
